export default {
  'report.invoice.form.type': 'Type',
  'report.invoice.form.type.partsInvoice': 'Invoice of Parts',
  'report.invoice.form.type.serviceInvoice': 'Service Invoice',
  'report.invoice.form.type.consumerInvoice': 'Consumer Invoice',
  'report.invoice.form.situation': 'Situation',
  'report.invoice.form.situation.authorized': 'Authorized',
  'report.invoice.form.situation.canceled': 'Canceled',
  'report.invoice.form.situation.denied': 'Denied',
  'report.invoice.form.situation.inTyping': 'In Typing',
  'report.invoice.form.situation.validated': 'Validated',
  'report.invoice.form.situation.processing': 'Processing',
  'report.invoice.form.situation.inCancellation': 'In Cancellation',
  'report.invoice.form.detailTheInvoiceItems': 'Detail the Invoice Items?',
  'report.invoice.form.moreOptions': 'More Options',
  'report.invoice.form.moreOptions.selectCustomers': 'Select Customers',
  'report.invoice.form.moreOptions.selectSuppliers': 'Select Suppliers',
  'report.invoice.form.selection.cfop': 'CFOP',
  'report.invoice.form.selection.insurer': 'Insurer',
  'report.invoice.form.selection.cstpis/cofins': 'CST PIS/COFINS',
};
